import { create } from '@bufbuild/protobuf';

import {
  CreateMessageDeepLinkRequest,
  CreateMessageDeepLinkRequestSchema,
  GetDeepLinkRequest,
  GetDeepLinkRequestSchema,
  RefreshDeepLinkDetailsRequest,
  RefreshDeepLinkDetailsRequestSchema,
} from 'APP/wsApi/wsAppApi/types/deeplink/deeplink_request_pb';
import {
  CreateMessageDeepLinkResponse,
  GetDeepLinkResponse,
  RefreshDeepLinkDetailsResponse,
} from 'APP/wsApi/wsAppApi/types/deeplink/deeplink_response_pb';

import { wsAppRequestManager } from '../WsAppApi';
import { WsRequest } from './request.types';

export function getDeepLinkRequest(
  data: WsRequest<GetDeepLinkRequest>
): Promise<GetDeepLinkResponse> {
  return wsAppRequestManager.request<GetDeepLinkResponse>({
    case: 'getDeepLink',
    value: create(GetDeepLinkRequestSchema, data),
  });
}

export function createMessageDeepLinkRequest(
  data: WsRequest<CreateMessageDeepLinkRequest>
): Promise<CreateMessageDeepLinkResponse> {
  return wsAppRequestManager.request<CreateMessageDeepLinkResponse>({
    case: 'createMessageDeepLink',
    value: create(CreateMessageDeepLinkRequestSchema, data),
  });
}

export function refreshDeepLinkDetailsRequest(
  data: WsRequest<RefreshDeepLinkDetailsRequest>
): Promise<RefreshDeepLinkDetailsResponse> {
  return wsAppRequestManager.request<RefreshDeepLinkDetailsResponse>({
    case: 'refreshDeepLinkDetails',
    value: create(RefreshDeepLinkDetailsRequestSchema, data),
  });
}
